var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for authority proposal operations.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_AUTHORITIES_PROPOSAL_DETAIL, CZNA_AUTHORITIES_PROPOSAL_SUBMIT, CZNA_AUTHORITIES_PROPOSAL_PUBLISH, CZNA_AUTHORITIES_PROPOSAL_APPROVE, CZNA_AUTHORITIES_PROPOSAL_FORWARD, CZNA_AUTHORITIES_PROPOSAL_REJECT, CZNA_AUTHORITIES_PROPOSAL_REBASE, CZNA_AUTHORITIES_PROPOSAL_REQUEST_CHANGES, CZNA_AUTHORITIES_PROPOSAL_MESSAGES, } from '../types/apiPaths';
var DEFAULT_LIMIT = 50;
/**
 * Builds URLSearchParams from proposal search parameters.
 * Status is always required and included. Other params are skipped when null/undefined.
 */
export var buildProposalSearchParams = function (params) {
    var searchParams = new URLSearchParams();
    searchParams.set('status', params.status);
    if (params.heading) {
        searchParams.set('heading', params.heading);
    }
    if (params.proposalType) {
        searchParams.set('proposalType', params.proposalType);
    }
    if (params.recordType) {
        searchParams.set('recordType', params.recordType);
    }
    // CZNA-593 — the two ownership filters. Both are plain equality filters on the row;
    // neither is an authorization control, which the backend enforces separately by
    // authority type.
    if (params.createdBy) {
        searchParams.set('createdBy', params.createdBy);
    }
    if (params.organizationId) {
        searchParams.set('organizationId', params.organizationId);
    }
    if (params.includeTotalCount) {
        searchParams.set('includeTotalCount', 'true');
    }
    if (params.sortBy) {
        searchParams.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
        searchParams.set('sortOrder', params.sortOrder);
    }
    if (params.afterSortValue) {
        searchParams.set('afterSortValue', params.afterSortValue);
    }
    if (params.afterId) {
        searchParams.set('afterId', params.afterId);
    }
    if (params.beforeSortValue) {
        searchParams.set('beforeSortValue', params.beforeSortValue);
    }
    if (params.beforeId) {
        searchParams.set('beforeId', params.beforeId);
    }
    if (params.limit !== undefined && params.limit !== null) {
        searchParams.set('limit', params.limit.toString());
    }
    return searchParams;
};
/**
 * Fetches authority proposals with required status filter and optional search, filtering,
 * sorting and pagination.
 */
export var fetchProposals = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var defaults, mergedParams, searchParams;
    return __generator(this, function (_a) {
        defaults = {
            sortBy: 'updatedAt',
            sortOrder: 'desc',
            limit: DEFAULT_LIMIT,
        };
        mergedParams = __assign(__assign({}, defaults), params);
        searchParams = buildProposalSearchParams(mergedParams);
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_PROPOSALS, "?").concat(searchParams), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-595 — fetches the proposal counts behind the workflow tab badges.
 *
 * One request covers all seven tabs. It carries only the ownership narrowing, because a
 * tab click clears the heading search and the type filters but keeps the ownership choice
 * (CZNA-593) — so those are exactly the params under which the badge's promise ("this is
 * what you get if you click") holds.
 */
export var fetchProposalTabCounts = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var searchParams, query;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            searchParams = new URLSearchParams();
            if (params.createdBy) {
                searchParams.set('createdBy', params.createdBy);
            }
            if (params.organizationId) {
                searchParams.set('organizationId', params.organizationId);
            }
            query = searchParams.toString();
            return [2 /*return*/, ky.get(query
                    ? "".concat(API_PATHS.CZNA_AUTHORITIES_PROPOSALS_COUNTS, "?").concat(query)
                    : API_PATHS.CZNA_AUTHORITIES_PROPOSALS_COUNTS, { headers: getHeaders() }).json()];
        });
    });
};
/**
 * CZNA-553 — query string for the printable approval list.
 *
 * Exported so the contract can be asserted without a network stub: `from`/`to` are the
 * only required params, and `recordType` is omitted rather than sent empty — an empty
 * `recordType=` would fail Spring's enum conversion with a 400 rather than meaning "all".
 */
export var buildPendingReportParams = function (params) {
    var searchParams = new URLSearchParams();
    searchParams.set('from', params.from);
    searchParams.set('to', params.to);
    if (params.recordType) {
        searchParams.set('recordType', params.recordType);
    }
    return searchParams;
};
/**
 * CZNA-553 — fetches the printable list of proposals awaiting approval in a period.
 *
 * One request is one printout: there is no pagination, and the response says when the
 * server's cap cut the list short.
 */
export var fetchPendingApprovalReport = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams;
    return __generator(this, function (_a) {
        searchParams = buildPendingReportParams(params);
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_PROPOSALS_PENDING_REPORT, "?").concat(searchParams), { headers: getHeaders() }).json()];
    });
}); };
/**
 * Creates a new authority proposal.
 */
export var createProposal = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(API_PATHS.CZNA_AUTHORITIES_PROPOSALS, {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Updates an existing authority proposal.
 */
export var updateProposal = function (ky, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.put(CZNA_AUTHORITIES_PROPOSAL_DETAIL(id), {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Fetches a single authority proposal by ID.
 */
export var fetchProposalDetail = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_PROPOSAL_DETAIL(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-1375 — deletes a DRAFT proposal. The backend allows it only for a draft and only
 * to its author or an admin (409 / 403 otherwise); the delete is hard, a draft has no
 * history. Answers 204 with no body.
 */
export var deleteProposal = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.delete(CZNA_AUTHORITIES_PROPOSAL_DETAIL(id), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Submits a DRAFT proposal for review.
 */
export var submitProposal = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_SUBMIT(id), {
                json: {},
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-581 — publishes a CREATE_NEW proposal directly as an authority record
 * ("Publikovat"), without any review of the proposal itself. Only for authority
 * types where {@link publishesImmediately} is true.
 */
export var publishProposal = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_PUBLISH(id), {
                json: {},
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-552 — forwards a locally reviewed proposal to the NK supervisor.
 * Two-stage authority types only (CZNA-581/v3.1 §2: subject, genre form,
 * chronological, conspect group — geographic publishes immediately instead);
 * publishes nothing.
 */
export var forwardProposal = function (ky, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_FORWARD(id), {
                json: request || {},
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Approves a proposal, publishing it as an authority record. For a two-stage
 * type the proposal must already be in PENDING_NATIONAL_REVIEW (CZNA-552).
 */
export var approveProposal = function (ky, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_APPROVE(id), {
                json: request || {},
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Rejects a PENDING_REVIEW proposal.
 */
/**
 * CZNA-1531 (F10) — after approval refused with TARGET_RECORD_CHANGED: moves the proposal's
 * base to the record's current version and names the fields the record changed meanwhile.
 */
export var rebaseProposal = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_REBASE(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
export var rejectProposal = function (ky, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_REJECT(id), {
                json: request,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Requests changes on a PENDING_REVIEW proposal.
 */
export var requestChanges = function (ky, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_REQUEST_CHANGES(id), {
                json: request,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-949 — the author answers a returned proposal in words. Changes neither the
 * proposal's state nor its data; the answer comes back as the new last thread item.
 */
export var replyToReturn = function (ky, id, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_PROPOSAL_MESSAGES(id), {
                json: { body: body },
                headers: getHeaders(),
            }).json()];
    });
}); };
